<template>
    <div>
        <el-card>
            <el-breadcrumb>
                <el-breadcrumb-item style="padding-bottom: 30px;"><span style="font-weight: bolder;">交易对下单人数</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <el-form :model="condition" :inline="true" label-width="150px">
                <el-form-item label="交易对：">
                    <el-input v-model="condition.pair"></el-input>
                </el-form-item>
                <el-form-item label="交易时间：" prop="time"
                              :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                    <el-date-picker v-model="condition.time" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间"
                                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="querySubmit()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="pairPersonList">
                <el-table-column prop="pair" label="交易对"></el-table-column>
                <el-table-column prop="total" label="下单量"></el-table-column>
            </el-table>
        </el-card>

        <br>
        <el-card>
            <el-form :model="tradeDeal" :inline="true">
                <el-form-item label="交易时间：" prop="time"
                              :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                    <el-date-picker v-model="tradeDeal.time" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间"
                                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="输入交易对" v-model="tradeDeal.pair"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="输入用户ID" v-model="tradeDeal.userId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportDeal()">导出交易数据信息</el-button>
                </el-form-item>
                <el-form-item label="默认导出ETP">
                    <el-switch v-model="tradeDeal.queryEtp" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="默认导出LT">
                    <el-switch v-model="tradeDeal.queryLt" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="是否导出联系方式">
                    <el-switch v-model="tradeDeal.contactWay" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="是否为运营导出">
                    <el-switch v-model="tradeDeal.operation" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
            </el-form>
        </el-card>
        <br>

        <el-card>
            <el-breadcrumb>
                <el-breadcrumb-item style="padding-bottom: 30px;"><span style="font-weight: bolder;">单个用户的交易数据导出（FROM ES）</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <el-form :model="singleDeal" :inline="true" ref="single">
                <el-form-item label="交易时间：" prop="time"
                              :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                    <el-date-picker v-model="singleDeal.time" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间"
                                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="输入交易对" v-model="singleDeal.pair"></el-input>
                </el-form-item>
                <el-form-item prop="userId" :rules="[{required: true, message: '请输入交易用户ID', trigger: 'blur'}]">
                    <el-input placeholder="输入用户ID" v-model="singleDeal.userId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportDealSingle()">导出交易数据信息</el-button>
                </el-form-item>
                <el-form-item label="是过滤与自己的交易记录">
                    <el-switch v-model="singleDeal.filterSelf" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import '../store';
    import {mapState, mapActions} from 'vuex';
    import api from '../api';

    export default {
        name: "pairPerson",

        data() {
            return {
                condition: {
                    pair: '',
                    time: []
                },
                tradeDeal: {
                    pair: '',
                    time: [],
                    userId: '',
                    startTime: '',
                    endTime: '',
                    queryEtp: true,
                    queryLt: true,
                    contactWay: false,
                    operation: false,
                },
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '当天',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime());
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三天',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ]
                },
                singleDeal: {
                    pair: '',
                    time: [],
                    userId: '',
                    startTime: '',
                    endTime: '',
                    filterSelf: false
                }
            }
        },

        computed: {
            ...mapState('tradeStatistic', ['pairPersonList'])
        },

        created() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth();
            let day = time.getDate();
            this.condition.time[0] = new Date(year, month, day, 0, 0, 0);
            this.condition.time[1] = new Date(year, month, day, 23, 59, 59);
            this.tradeDeal.time[0] = new Date(year, month, day, 0, 0, 0);
            this.tradeDeal.time[1] = new Date(year, month, day, 23, 59, 59);
        },

        methods: {
            ...mapActions('tradeStatistic', ['getPairPerson']),

            querySubmit() {
                let data = {
                    pair: this.condition.pair,
                    startTime: this.condition.time[0],
                    endTime: this.condition.time[1]
                }
                this.getPairPerson(data);
            },

            exportDeal() {
                this.tradeDeal.startTime = this.tradeDeal.time[0];
                this.tradeDeal.endTime = this.tradeDeal.time[1];
                api.exportTradeDeal(this.tradeDeal).then(response => {
                    const fileName = "交易信息计表" + this.tradeDeal.time[0] + "-" + this.tradeDeal.time[1] + ".xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },

            exportDealSingle() {
                this.$refs['single'].validate((valid) => {
                    if (valid) {
                        this.singleDeal.startTime = this.singleDeal.time[0];
                        this.singleDeal.endTime = this.singleDeal.time[1];
                        api.exportTradeDealSingle(this.singleDeal).then(response => {
                            const fileName = "交易信息计表" + this.singleDeal.time[0] + "-" + this.singleDeal.time[1] + ".xlsx";
                            const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                            if ('download' in document.createElement('a')) {
                                const link = document.createElement('a');
                                link.download = fileName;
                                link.style.display = 'none';
                                link.href = URL.createObjectURL(blob);
                                document.body.appendChild(link);
                                link.click();
                                URL.revokeObjectURL(link.href);
                            } else {
                                navigator.msSaveBlob(blob, fileName);
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
